import axios from 'config/axiosConfig'
import { go } from "keys/apis"

export const getPricesFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}prices/`)
}
